import { useContext } from "react";
import { LocaleContext, Locale } from "./LocaleProvider";

const useLocale = (): [Locale, (locale: Locale) => void] => {
  const { locale, setLocale } = useContext(LocaleContext);
  return [locale, setLocale];
};

export default useLocale;
